<kendo-stacklayout orientation="vertical">
  <kendo-stacklayout orientation="horizontal" id="manage-panel-header" [align]="{ vertical: 'middle' }">
    <div id="manage-panel-header-meta">
      <h2>{{ $headerMeta() }}</h2>
      @let status = $currentStatus();
      @if (status) {
        <unity-chip-workflow-state-shared class="workflow-chip" [name]="status.name" [value]="status.enum_value" />
      }
    </div>
    <div id="manage-panel-edit">
      @if ($isEditable() === true) {
        @if ($editState().editing === false) {
          <button
            kendoButton
            themeColor="base"
            class="tool-button"
            type="button"
            title="EditButton"
            [svgIcon]="editIcon"
            [disabled]="$canEdit() !== true"
            (click)="setEditState(true)">
            Edit
          </button>
        }
      }
    </div>
  </kendo-stacklayout>
  <kendo-card class="layout-card general-card" width="auto">
    <form
      #DetailForm
      id="manage-form"
      class="general-form noscroll"
      [formGroup]="$formGroup()"
      [unityFormFillMode]="$editState().fillMode"
      (ngSubmit)="onSave()">
      <kendo-card-body>
        <ng-content>
          <!-- Content from subcomponent -->
        </ng-content>
      </kendo-card-body>
    </form>
    <kendo-card-footer>
      <kendo-stacklayout [gap]="5" [align]="{ horizontal: 'end' }">
        <unity-chip-audit-popup-shared class="audit-data" [data]="$resource()" />
        @if ($editState().editing === true) {
          <button
            kendoButton
            title="CancelButton"
            themeColor="error"
            type="button"
            [svgIcon]="cancelIcon"
            [formGroup]="$formGroup()"
            (click)="setEditState(false)">
            Cancel
          </button>
          @let submitLoading = $submitLoading();
          <ng-content select="[submit-options]" />
          <button
            form="manage-form"
            themeColor="secondary"
            kendoButton
            title="SaveButton"
            type="submit"
            [svgIcon]="saveIcon"
            [disabled]="submitLoading ?? false">
            @if (submitLoading === true) {
              <kendo-loader id="submit-loading" type="infinite-spinner" size="small" themeColor="info" />
            }
            Save
          </button>
        }
      </kendo-stacklayout>
    </kendo-card-footer>
  </kendo-card>
</kendo-stacklayout>
